import React from "react";
import AppForConnectionForm from "./form.js";
import styles from "./styles.module.css";

import askuZ4 from "./askuZ4.png";

class AppForConnect extends React.Component {
  render() {
    const { detect } = require("detect-browser");
    const browser = detect();
    const firefox = browser.name === "firefox";

    return (
      <div>
        <div
          style={{
            display: "table",
            width: "100%",
            paddingLeft: "3em",
            paddingRight: "3em"
          }}
        >
          <div style={{ display: "table-row" }}>
            <div style={{ display: "table-cell", verticalAlign: "top" }}>
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      backgroundColor: "#2679bd",
                      fontWeight: "600",
                      color: "white",
                      fontSize: "1.15vw",
                      paddingBottom: "0.5em",
                      paddingTop: "0.5em",
                      borderRadius: "6px 6px 0px 0px"
                    }}
                  >
                    <span style={{ paddingLeft: "1.2em" }}>
                      ЗАЯВКА НА ПОДКЛЮЧЕНИЕ
                    </span>
                  </div>
                </div>
              </div>
              <div className={styles.connectionFormContainer} style={{ marginBottom: firefox ? "6em" : "0em" }}>
                <div className="formWrapper">
                  <AppForConnectionForm />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "table-cell",
                verticalAlign: "top",
                paddingLeft: "2em"
              }}
                    >
                        <div style={{ textAlign: "center", backgroundColor: "white", paddingTop: "1em" }}>
                <img src={askuZ4} alt="askuZ4" style={{ height: "auto", width: "95%" }} />
                <div style={{ fontWeight: "600", width: "95%", padding: "0em 7em 2.5em" }}>
                  Устройство передачи данных и теплосчетчик должны иметь общий
                  источник питания (требование МОЭК)
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AppForConnect;
